import {cssVar} from "../../../components/cssInJs"
import highcharts from "highcharts";

export default function (angularModule) {
  angularModule.directive('cmNetPromoterScore', () => (
    {
      restrict: 'E',
      replace: true,
      template: require('./cmNetPromoterScoreDirective.html'),
      scope: {
        netPromoterScoreData: '=',
        optionalDescription: '=',
        isLoading: '='
      },
      controller: ($scope, $element, $timeout, $window) => {
        $scope.Math = $window.Math

        const render = () => {

          $scope.promoters = $scope.netPromoterScoreData.promoters
          $scope.detractors = $scope.netPromoterScoreData.detractors
          $scope.total = $scope.netPromoterScoreData.total
          $scope.passives = $scope.netPromoterScoreData.passives

          let centerElement = null
          let descriptionElement = null

          const positiveColor = cssVar('--success');
          const neutralColor = cssVar('--warning');
          const negativeColor = cssVar('--danger');
          const bodyFontColor = cssVar('--body-color');

          const drawCenter = (chart) => {
            let xCenter = chart.series[0].center[0] + chart.series[0].getPlotBox().translateX,
              yCenter = chart.series[0].center[1] + chart.series[0].getPlotBox().translateY
            let score = $scope.netPromoterScoreData.total && ($scope.netPromoterScoreData.total > 0 ? Math.round($scope.netPromoterScoreData.promoters / $scope.netPromoterScoreData.total * 100) - Math.round($scope.netPromoterScoreData.detractors / $scope.netPromoterScoreData.total * 100) : 0);
            let maxSize = chart.plotBox.width <= chart.plotBox.height ? chart.plotBox.width : chart.plotBox.height
            let fontMultiplier = score > -100 ? .30 : .25
            let fontSize = maxSize * fontMultiplier

            if (centerElement !== null) {
              centerElement.destroy()
            }
            if (descriptionElement !== null) {
              descriptionElement.destroy()
            }
            centerElement = chart.renderer.text(score, xCenter, yCenter + (fontSize / 4)).attr({'text-anchor': 'middle'}).css({
              'font-size': `${fontSize}px`,
              color: bodyFontColor
            })
            centerElement.add()

            descriptionElement = chart.renderer.text("NPS Score", xCenter, yCenter + fontSize / 1.5).attr({'text-anchor': 'middle'}).css({
              'font-size': `${fontSize / 4}px`,
              color: bodyFontColor
            })
            descriptionElement.add()
          }

          highcharts.chart(document.querySelector('.netPromoterScoreChart'), {
            exporting: {
              enabled: false
            },
            credits: {
              enabled: false
            },
            chart: {
              marginLeft: 20,
              //marginRight: 40,

              events: {
                render: function () {
                  drawCenter(this)
                }
              }
            },
            title: {
              text: ""
            },
            plotOptions: {
              pie: {
                dataLabels: {
                  enabled: false
                }
              }
            },
            series: [
              {
                name: "Response Count",
                type: 'pie',
                innerSize: '80%',
                data: [
                  {name: 'Promoters', y: $scope.netPromoterScoreData.promoters, color: positiveColor},
                  {name: 'Detractors', y: $scope.netPromoterScoreData.detractors, color: negativeColor},
                  {name: 'Passives', y: $scope.netPromoterScoreData.passives, color: neutralColor}
                ],
              }
            ]

          })
        }

        $scope.$watch("netPromoterScoreData", render)
      }
    }
  ))
}
